/* Layouts */
// import { AuthLayout } from 'components/layouts/AuthLayout';
// import { MainLayout } from 'components/layouts/MainLayout';

import { AuthLayout } from 'components/layouts/AuthLayout';
import { MainLayout } from 'components/layouts/MainLayout';
import { AllocatedVideo } from 'pages/AllocatedVideo';
import { Login } from 'pages/auth/Login';
import { Categories } from 'pages/Categories';
import { ContentCreators } from 'pages/ContentCreators';
import { ContentCreatorView } from 'pages/ContentCreatorView';
import { Dashboard } from 'pages/Dashboard';
import { EnterpriseCreate } from 'pages/EnterpriseCreate';
import { Enterprises } from 'pages/Enterprises';
import { EnterpriseUpdate } from 'pages/EnterpriseUpdate';
import { EnterpriseView } from 'pages/EnterpriseView';
import { Videos } from 'pages/Videos';

interface Route {
  path: string;
  component?: any;
  layout?: any;
  redirectTo?: string;
  isSecured?: boolean;
  isAuthScreen?: boolean;
}

export const routes: Route[] = [
  {
    path: '/auth',
    redirectTo: '/auth/login',
  },
  // {
  //   path: '/auth/login',
  //   component: Login,
  //   layout: AuthLayout,
  //   isAuthScreen: true,
  // },
  {
    path: '/auth/login',
    component: Login,
    layout: AuthLayout,
  },
  {
    path: '/',
    component: Dashboard,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/videos',
    component: Videos,
    layout: MainLayout,
    isSecured: true,
  },
  // {
  //   path: '/profile',
  //   component: Profile,
  //   layout: MainLayout,
  //   isSecured: true,
  // },
  {
    path: '/content-creators',
    component: ContentCreators,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/content-creators/:id',
    component: ContentCreatorView,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/enterprises',
    component: Enterprises,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/enterprises/:id',
    component: EnterpriseView,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/enterprises/create',
    component: EnterpriseCreate,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/enterprises/update/:id',
    component: EnterpriseUpdate,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/allocated-videos',
    component: AllocatedVideo,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/categories',
    component: Categories,
    layout: MainLayout,
    isSecured: true,
  },
];

export default routes;
